
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ServiceData } from '@/types/serviceTypes';

interface RelatedServicesProps {
  service: ServiceData;
}

const RelatedServices = ({ service }: RelatedServicesProps) => {
  if (!service.relatedServices) return null;
  
  return (
    <div>
      <h3 className="text-2xl font-serif font-bold mb-6 text-pkstone-900">
        Related Services
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {service.relatedServices.map((relatedService) => (
          <Link 
            key={relatedService.id} 
            to={`/services/${relatedService.id}`}
            className="bg-white p-4 rounded-lg border border-pkgreen-100 hover:border-pkgreen-300 hover:shadow-md transition-all group flex justify-between items-center"
          >
            <span className="text-pkstone-800 font-medium">
              {relatedService.title}
            </span>
            <ArrowRight className="h-5 w-5 text-pkgreen-500 group-hover:translate-x-1 transition-transform" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedServices;
